import {
  Card,
  Input,
  SimpleGrid,
  SimpleGridProps,
  Stack,
  Text
} from '@mantine/core'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { SelectableCard } from '@/components/ui-shared/SelectableCard/SelectableCard'
import { Gpu } from '@/types/device'

const CARD_HEIGHT = 100

type GpuSelectorProps = {
  gpus: Gpu[]
  value: number[]
  label?: ReactNode
  description?: ReactNode
  error?: ReactNode
  cols?: SimpleGridProps['cols']
  cardHeight?: number
  renderDetails?: (gpu: Gpu) => ReactNode
  single?: boolean
  onChange: (value: number[]) => void
}

export const GpuSelector = ({
  gpus,
  value,
  label,
  description,
  error,
  cols = { base: 2, sm: 4 },
  cardHeight = CARD_HEIGHT,
  renderDetails,
  single = false,
  onChange
}: GpuSelectorProps) => {
  const handleToggle = (index: number) => {
    if (single) {
      onChange([index])
      return
    }

    onChange(
      value.includes(index)
        ? value.filter((i) => i !== index)
        : [...value, index].sort((a, b) => a - b)
    )
  }

  return (
    <Input.Wrapper label={label} description={description} error={error}>
      <SimpleGrid cols={cols} my={4}>
        {gpus.map((gpu) => (
          <SelectableCard
            key={gpu.index}
            height={cardHeight}
            isSelected={value.includes(gpu.index)}
            onClick={() => handleToggle(gpu.index)}
          >
            <Card.Section py="xs" inheritPadding>
              <Stack gap={4} align="center">
                <Text size="sm" fw={600} ta="center">
                  <FormattedMessage
                    id="devices.gpu.indexLabel"
                    values={{ index: gpu.index }}
                  />
                </Text>

                <Text size="xs" c="dimmed" ta="center">
                  {gpu.name}
                </Text>

                {renderDetails?.(gpu)}
              </Stack>
            </Card.Section>
          </SelectableCard>
        ))}
      </SimpleGrid>
    </Input.Wrapper>
  )
}
